import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import MembersContent from "modules/Members";
import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const MembersPage: React.FC = () => {
  setTitle("Membership List");
  return (
    <Auth>
      <Layout>
        <MembersContent />
      </Layout>
    </Auth>
  );
};

export default MembersPage;
